// node modules
import Headroom from 'headroom.js'
import $ from 'jquery'
import './elengorn.js'
import './form';
// import SelectPure from "select-pure";

(() => {
  /*
  * Navbar sticky
  */
  let $navBar = document.querySelector('.navbar')
  let navbarHeadroom  = new Headroom($navBar, {
    offset: $navBar.offsetHeight,
    tolerance: 3
  })
  navbarHeadroom.init()
  // On Document Loaded
  document.addEventListener('DOMContentLoaded', () => {
    let $listingHead = document.querySelector('.listing-heading')

    if ( $listingHead ) {
      $listingHead.posInY = parseInt($listingHead.offsetTop) + parseInt($navBar.offsetHeight)

      window.addEventListener('resize', () => {
        $listingHead.posInY = parseInt($listingHead.offsetTop) + parseInt($navBar.offsetHeight)
      })
      window.addEventListener('scroll', () => {
        if ( window.scrollY >= $listingHead.posInY ) {
          $listingHead.classList.add('on-top')

          $listingHead.style.removeProperty('transform')
          $listingHead.style.removeProperty('transition')
        } else {
          if ( $listingHead.classList.contains('heading-in-content') ) {
            if ( window.scrollY > ( $listingHead.posInY - $navBar.offsetHeight ) && window.scrollY < $listingHead.posInY ) {
              $listingHead.classList.add('dynamic-top')

              $listingHead.style.transform = `translateY(${$navBar.offsetHeight - ($listingHead.posInY - window.scrollY)}px)`
              $listingHead.style.transition = `none`
            } else {
              $listingHead.classList.remove('dynamic-top')

              $listingHead.style.removeProperty('transform')
              $listingHead.style.removeProperty('transition')
            }
          }
          $listingHead.classList.remove('on-top')
        }
      })
    }
  })

  /**
   * Accordion functionality
   */
  const toggleAccordion = ev => {
    // Enable only if target is toggler or heading
    if ( ev.target.classList.contains('accordion-toggler') || ev.target.tagName === "H2" ) {
      ev.currentTarget.classList.toggle('open')
    }
  }

  const $accordions = document.querySelectorAll('.featured-content .accordion')

  if ( $accordions ) {
    $accordions.forEach( $accordion => $accordion.addEventListener( 'click', toggleAccordion ) )
  }

  /* Navbar toggle */
  const $navBarToggler = $navBar.querySelector('.navbar-toggle')

  if ( $navBarToggler ) {
    $navBarToggler.addEventListener( 'click', _ => {
      $navBar.classList.toggle('open');
    })
  }

  const $navBarOverlay = $navBar.querySelector('.navbar-overlay')

  if ( $navBarOverlay ) {
    $navBarOverlay.addEventListener('touchstart', () => {
      $navBar.classList.remove('open')
    })
  }

  const $closeMenu = $navBar.querySelectorAll('[data-close]')

  if ( $closeMenu && $closeMenu.length > 0 ) {
    $closeMenu.forEach($close => {
      $close.addEventListener('click', _ => {
        $navBar.classList.remove('open')
      })
    })
  }

  /**
   * Widgets functionality
   */
  const $Widgets = document.querySelectorAll('.widget')
  const initialHash = location.hash
  let currentHash = initialHash

  const closeAllWidgets = () => {
    if ( $Widgets )
      $Widgets.forEach( widget => widget.classList.remove('open') )

    let targets = document.querySelectorAll('[data-widget]')
    targets.forEach( link => link.classList.add('widget-closed') )
  }

  const openWidget = widgetName => {
    if ( widgetName && widgetName.length > 0 ) {
      closeAllWidgets()

      const $widget = document.querySelector(widgetName)
      if ( $widget ) {
        $widget.classList.add('open')

        let targets = document.querySelectorAll(`a[href="${widgetName}"]`)

        targets.forEach(link => link.classList.remove('widget-closed'))
      }
    }
  }

  window.addEventListener( 'hashchange', ev => {
    let newHash = location.hash

    if ( newHash && newHash !== currentHash ) {
      openWidget(newHash)
    } else {
      closeAllWidgets()
    }

    // Replace current value
    currentHash = newHash
  })

  /* Open widget on initial hash */
  if (initialHash.length > 0) {
    openWidget(initialHash)
  }

  /* Close Widgets listener */
  $Widgets.forEach( $widget => {
    $widget
      .querySelectorAll('[data-close]')
      .forEach( closeBtn => closeBtn.addEventListener('click', () => {
          // $widget.classList.remove('open')

          // Change hash to null target
          window.location.hash = '_'
          // Replace state to clear hash
          if ( window.history && window.history.replaceState ) {
            window.history.replaceState('', '', window.location.pathname)
          } else {
            window.location.href = window.location.href.replace(/#.*$/, '#');
          }
        })
      )
  })

  /**
   * Open Widgets from anchors
   * [Webflow] removes hash functionality
   */
  const $anchorLinks = document.querySelectorAll('a[href^="#"]')

  $anchorLinks.forEach(link => {
    if ( link.hash.length > 0 ) {
      let $target = document.querySelector(link.hash)
      if ( $target && $target.classList.contains('widget') ) {
        link.setAttribute('data-widget', link.hash)
        link.classList.add('widget-closed')
        link.addEventListener('click', ev => {
          link.classList.remove('widget-closed')
          ev.stopPropagation()
          // ev.preventDefault()
          // window.location.hash = link.hash
        })
      }
    }
  })

  /* Agent selector */
  const $selectAgent = document.querySelector('#AgentSelector');

  if ( $selectAgent ) {
    $selectAgent.addEventListener('change', ev => {
      let value = ev.target.value
      let photos = document.querySelectorAll('[data-agent-photo]')

      photos.forEach(img => {
        if ( img.getAttribute('data-agent-photo') !== value ) {
          img.classList.remove('active')
        } else {
          img.classList.add('active')
        }
      })

    })
  }

  /**
   * Custom select functionality
   * - Simuluates select element with .form-input class
   * - Toggle active class
   */
  let $customSelects = document.querySelectorAll('.custom-select')

  const CUSTOM_SELECT_TRANSITION = 200

  /**
   * Show or hide optgroup labels if they are necessary for options
   * @param {HTMLSelectElement} $select
   */
  const toggleSelectLabels = $select => {
    let placeholder   = $select.querySelector('.custom-select-placeholder')
    let selectedLabel  = $select.querySelector('[data-label-for="selected"]')
    let availableLabel = $select.querySelector('[data-label-for="available"]')
    let options  = $select.querySelectorAll('input[type="checkbox"]')
    let selected = $select.querySelectorAll('input[type="checkbox"]:checked')

    if ( selectedLabel ) {
      if ( selected && selected.length > 0 ) {
        selectedLabel.classList.remove('empty')
        if( selected.length > 1 ) {
          selectedLabel.classList.add( 'plural' );
        } else {
          selectedLabel.classList.remove( 'plural' );
        }
        let currentPlaceholder = selected.length > 1 ? placeholder.getAttribute( 'data-selected-plural' ) : placeholder.getAttribute( 'data-selected-singular' );
        placeholder.textContent = `${selected.length} ${currentPlaceholder}`;
      } else {
        selectedLabel.classList.add('empty')
        placeholder.textContent = $select.getAttribute('data-default-label')
      }
    }

    if ( availableLabel ) {
      if ( options && options.length > selected.length ) {
        availableLabel.classList.remove('empty')
      } else {
        availableLabel.classList.add('empty')
      }
    }
  }

  $customSelects.forEach( $select => {
    $select.addEventListener('click', () => {
      let $customSelectWrapper = $select.querySelector('.custom-select-wrapper')
      if ( $customSelectWrapper ) $customSelectWrapper.classList.toggle('open')

      $select.classList.toggle('active')
    })

    let options = $select.querySelectorAll('.custom-select-options .optgroup, .custom-select-options .custom-select-option')
    let pos     = 1

    let defaultLabel = $select.querySelector('.custom-select-placeholder')
    if ( defaultLabel ) {
      $select.setAttribute('data-default-label', defaultLabel.textContent)
    }

    options.forEach( option => {
      // get checkbox
      let check = option.querySelector('input')

      let isChecked = check && check.checked

      if ( option.classList.contains('optgroup') ) {
        pos += 99
      }

      if ( check ) {
        check.addEventListener('change', () => {
          option.classList.add('moving')

          setTimeout(() => {
            option.classList.remove('moving')
          }, CUSTOM_SELECT_TRANSITION)

          if ( check.checked ) {
            option.style.order = parseInt(option.style.order) - 99
          } else {
            option.style.order = parseInt(option.style.order) + 99
          }

          // Show or hide labels on change values
          toggleSelectLabels($select)
        })
      }
      option.style.order = isChecked ? pos - 99 : pos

      // Increase position with index
      pos ++
    })
    // Show or hide labels once
    toggleSelectLabels($select)
  })

  /*
   * Compare items functionality
   * *** Dummy use for Webflow, replace what you need on integration ***
   */
  const totalInCompare = () => {
    let properties = localStorage.getItem('compare-properties');
    if ( !properties ) {
      return 0 // Empty or doesn't exist
    } else {
      // There'is properties ID's
      return properties.split(',').length
    }
   }

  /**
   * Show or hide boxes if there's compare elements
   * @param int totalInCompare
   */
  const toggleCompareBox = ( total = totalInCompare() ) => {

    
    // There are 2 elements, desktop and mobile
    const $compareBox = document.querySelector('.compare-notification')
    const $compareButtonMobile = document.querySelector('.compare-btn')
    if( $compareBox === null || $compareButtonMobile === null )
      return false;

    let $totalCompareLabels = document.querySelectorAll('[data-compare-total]')
    if( $totalCompareLabels === null )
      return false;

    $totalCompareLabels.forEach( label => {
      label.setAttribute( 'data-compare-total', total );
      label.querySelector( 'span' ).innerHTML = total
    })
    if( total > 0 ) {
      if( !$compareBox.classList.contains( 'show' ) )
        $compareBox.classList.add( 'show' )
      if( !$compareButtonMobile.classList.contains( 'show' ) )
        $compareButtonMobile.classList.add( 'show' )
    } else {
      if( $compareBox.classList.contains( 'show' ) )
        $compareBox.classList.remove( 'show' )
      if( $compareButtonMobile.classList.contains( 'show' ) )
        $compareButtonMobile.classList.remove( 'show' )
    }
  }

  // Call in first time
  toggleCompareBox();

  // Get "COMPARE" buttons
  let $compareButtons = document.querySelectorAll('[add-to-compare]')
  /**
   * Add to Compare listener
   * - Prevents click default
   * - Reads [add-to-compare] {Property_ID}
   * - Calls `addToCompare` function which is a dummy function to simulate a request
   * - Adds [disabled] attribute to button to prevent duplicated requests
   */
  const compareListener = ev => {
    ev.preventDefault()
    let $button = ev.target

    let propertyID = parseInt($button.getAttribute('add-to-compare')) || null
    if ( propertyID ) {
      let loading = $button.getAttribute('data-loading-text')
      let complete = $button.getAttribute('data-complete-text')
      // Disable button and Update text
      $button.setAttribute('disabled', 'disabled')
      $button.removeEventListener('click', compareListener)

      $button.textContent = loading
      // Execute request
      addToCompare(propertyID, $button)
        .then(res => {
          let currentTotal = res.length

          let ids = getPropertiesIDs(res)

          localStorage.setItem('compare_properties', ids)
          toggleCompareBox(currentTotal)
          $button.textContent = complete
        })
        .catch(err => {
          throw new Error(err)
        })
    }
  }

  $compareButtons.forEach($button => {
    //$button.addEventListener('click', compareListener)
  })

  const getPropertiesIDs = properties => {
    if ( !Array.isArray( properties ) ) {
      return ''
    }
    return properties.map(property => property.id).join(',')
  }

  // compare properties
  let propertiesGrid = document.querySelector( '.w-layout-grid.properties-container' );
  if( propertiesGrid !== null ) {
    const renderCompareTable = () => {
      let properties = localStorage.getItem( 'compare-properties' );
      if( properties !== null && properties.length > 0 ) {
        let compareFormData = new FormData();
        compareFormData.append( 'properties', properties );
        // retrieve table entry for id
        fetch( `/wp-admin/admin-ajax.php?action=render_compare_table`, {
          method: 'POST',
          body: compareFormData
        } )
        .then( res => res.text() )
        .then( result => {
          // retrieve compare widget container
          const compareWidget = document.querySelector( '.compare-container' );
          if( compareWidget !== null )
            compareWidget.innerHTML = result;
        } )
        .catch( error => { 
          console.log( error );
        } );
      }
    }
    // init compare table if exists
    renderCompareTable();
    const propertyGridClickListener = event => {
      let target = event.target.closest( '[property-id]' );
      if( target !== null ) {
        event.preventDefault();
        const propertyId = target.getAttribute( 'property-id' );
        // Update localStorage value
        let properties = localStorage.getItem( 'compare-properties' ) || '';
        properties = properties.length > 0 ? properties.split( ',' ) : [];
        if( !properties.includes( propertyId ) ) {
          target.classList.add( 'added' );
          properties.push( propertyId );
        } else {
          target.classList.remove( 'added' );
          properties.splice( properties.indexOf( propertyId ), 1 );
        }
        // only allow 3 properties at a time
        if( properties.length > 4 )
          properties.shift();
        localStorage.setItem( 'compare-properties', properties );
        if( properties.length > 0 )
          renderCompareTable();
        toggleCompareBox( properties.length )
      }
    }
    propertiesGrid.addEventListener( 'click', propertyGridClickListener );
    // init compared properties
    ( () => {
      let properties = localStorage.getItem( 'compare-properties' ) || '';
      properties = properties.length > 0 ? properties.split( ',' ) : [];
      if( !properties.length )
        return;
      properties.map( property => {
        let propertyElement = document.querySelector( `[property-id='${property}']` );
        if( propertyElement !== null )
          propertyElement.classList.add( 'added' );
      } )
    } ) ();
  }
  
})()

window.makeInfoWindowEvent = (map, infowindow, contentString, marker) => {
  google.maps.event.addListener(marker, 'click', function() {
    infowindow.setContent(contentString);
    infowindow.open(map, marker);
  });
};

window.create_map_markers = (map, markerClusterer, bounds, properties, isFirst, isLast) => {
  if(typeof wpapi !== undefined)  {
    if (self.fetch) {
      var infowindow = new google.maps.InfoWindow();
      fetch(wpapi.url + "?action=" + wpapi.get_marker.action + "&nonce=" + wpapi.get_marker.nonce + "&properties=" + properties, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(locations) {
        locations.map(function(location, i) {
          if(location === null) return;
          var marker =  new google.maps.Marker({
            position: location.geodata
          });

          makeInfoWindowEvent(map, infowindow, location.content, marker);

          bounds.extend(marker.position);

          markerClusterer.addMarker(marker);
        });
        
        if(isFirst) {
          map.fitBounds(bounds);
        }

        if(isLast) {
          var loading_indicator = document.querySelector(".loading-indicator");

          if(loading_indicator !== null) {
            loading_indicator.classList.remove("active");
          }
        }
      });
    }
  }
};

/**
 * Properties google map init function
 */
window.initPropertiesMap = () => {
  if(typeof locations !== undefined && Array.isArray(locations)) {

    var map = new google.maps.Map(document.getElementById('properties_map'), {
      zoom: 7,
      center: {lat: 20.6520484, lng: -105.236069}
    });

    var markerClusterer = new MarkerClusterer(map, [], {
      styles: [
        {
          width: 30,
          height: 30,
          className: 'clustericon-1'
        },
        {
          width: 40,
          height: 40,
          className: 'clustericon-2'
        },
        {
          width: 50,
          height: 50,
          className: 'clustericon-3'
        }
      ],
      clusterClass: 'clustericon'
    });
    var bounds = new google.maps.LatLngBounds();
    var numLocations = locations.length;
    var index = 0;
    var loading_indicator = document.querySelector(".loading-indicator");

    if(loading_indicator !== null) {
      loading_indicator.classList.add("active");
    }
    
    locations.forEach(chunk => {
      create_map_markers(map, markerClusterer, bounds, chunk, index == 0, index >= (numLocations - 1));
      index++;
    });
  }
}

var locations = typeof property_markers !== 'undefined' ? JSON.parse( property_markers ) : [];

// developments
const initDevelopmentGalleryClick = () => {
  // retrieve gallery link
  let galleryLink = document.querySelector( '.development-gallery-thumbnails' );
  if( galleryLink === null ) return;
  const onGalleryClick = ( e ) => {
    galleryElement.click();
  }
  // retrieve gallery element
  let galleryElement = document.querySelector( '.bound-gallery' );
  if( galleryElement === null ) return;
  galleryLink.addEventListener( 'click', onGalleryClick );
}
initDevelopmentGalleryClick();